import moment from 'moment-timezone';
import { useMemo } from 'react';

// To prevent unintentional device parsing and shifting we
// need to associate the given date time directly
// as the clinic's timezone
export function useClinicTime(dateTime: string, ianaTimeZoneId: string | undefined) {
    return useMemo(() => {
        if (!dateTime || !ianaTimeZoneId) return null;
        return moment.tz(dateTime, ianaTimeZoneId);
    }, [ianaTimeZoneId, dateTime]);
}
